/**
 * Test/demo environment helpers.
 *
 * Demo companies (sandbox workspaces and the shared "TEST" company) all read
 * from a single pool of sample customers instead of owning their own copies.
 * Those rows are flagged `is_shared_demo`. Row-level security only exposes the
 * pool to demo companies, so the filter below is safe to use everywhere: a real
 * company simply never sees the shared rows.
 */
export const companyOrSharedDemo = (companyId: string) =>
  `company_id.eq.${companyId},is_shared_demo.eq.true`;

/**
 * Customer visibility for a company: its own (legacy) customers, the shared demo
 * pool, and Mowzi-sourced customers, which belong to no company.
 */
export const companyCustomerScope = (companyId: string) =>
  `company_id.eq.${companyId},is_shared_demo.eq.true,and(company_id.is.null,source.eq.Mowzi)`;

/** Query string flag that keeps a session inside the guided demo experience. */
export const DEMO_FLAG_KEY = "mowzi_demo_session";
